(function($) {

  // Agenda items open en dicht (toggle)
  $('.agenda-item-header').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('open').next().slideToggle();
  });

  // Auto scroll naar actief agenda item
  const urlParams = new URLSearchParams(window.location.search);
  const agenda_id = urlParams.get('show');

  console.log( agenda_id)

  if( agenda_id ) {
    console.log("idd");
    document.getElementById('AI_' + agenda_id ).scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    document.getElementById('AI_' + agenda_id ).style.display = 'block';
  }

})(jQuery);